import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { RadioList } from 'ui/radioList';
import { fontWeights, spacing, subtitle2 } from 'ui/theme';

const BulkUpdates = styled(RadioList)`
  display: flex;
  flex-direction: column;
  gap: ${spacing.threeQuarter};
  ${subtitle2};
  font-weight: ${fontWeights.bold};
`;

export enum BulkUpdateOption {
  OnlyFutureCampaigns = 'only-future-campaigns',
  ActiveFutureCampaigns = 'active-future-campaigns',
}

const BULK_UPDATE_OPTIONS = [
  {
    description: 'Draft, ready, recurring, scheduled',
    id: 'only-future-campaigns',
    name: 'Only future campaigns',
    value: BulkUpdateOption.OnlyFutureCampaigns,
  },
  {
    description: 'Draft, ready, recurring, scheduled, running (triggered-only)',
    id: 'active-future-campaigns',
    name: 'Active & future campaigns',
    value: BulkUpdateOption.ActiveFutureCampaigns,
  },
];

export const ALERT_BULK_UPDATE_FIELD_NAME = 'bulkUpdateSetting';

type Props = {
  bulkUpdateSetting: BulkUpdateOption;
  onBulkUpdateChange: Dispatch<SetStateAction<BulkUpdateOption>>;
};

export const AlertBulkUpdateSettings = ({ bulkUpdateSetting, onBulkUpdateChange }: Props) => {
  return (
    <BulkUpdates
      label="Apply changes to"
      name={ALERT_BULK_UPDATE_FIELD_NAME}
      options={BULK_UPDATE_OPTIONS}
      onSelect={onBulkUpdateChange}
      value={bulkUpdateSetting}
    />
  );
};
